export default function () {
    return {
        customerIsLogin: false,
        intervalId: null,
        init() {
            window.require(
                ['Magento_Customer/js/customer-data'],
                (customerData) => {
                    this.checkCustomerIsLogin(customerData);
                    this.refreshCustomerDataPeriodically(customerData);
                }
            );
        },
        checkCustomerIsLogin(customerData) {
            const customer = customerData.get('customer')();
            customerData.reload(['customer'], false);

            if (
                customer &&
                customer.firstname &&
                customer.firstname.length > 0
            ) {
                this.customerIsLogin = true;
                clearInterval(this.intervalId);
            } else {
                this.customerIsLogin = false;
            }
        },
        refreshCustomerDataPeriodically: function (customerData) {
            let counter = 0;

            this.intervalId = setInterval(() => {
                this.checkCustomerIsLogin(customerData);
                counter++;

                if (counter >= 10) {
                    clearInterval(this.intervalId);
                }
            }, 1000);
        }
    };
}
